import { render, staticRenderFns } from "./AccordionButton.vue?vue&type=template&id=6ab2f69d"
import script from "./AccordionButton.vue?vue&type=script&lang=js"
export * from "./AccordionButton.vue?vue&type=script&lang=js"
import style0 from "./AccordionButton.vue?vue&type=style&index=0&id=6ab2f69d&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab2f69d')) {
      api.createRecord('6ab2f69d', component.options)
    } else {
      api.reload('6ab2f69d', component.options)
    }
    module.hot.accept("./AccordionButton.vue?vue&type=template&id=6ab2f69d", function () {
      api.rerender('6ab2f69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/AccordionButton.vue"
export default component.exports